import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base.component';
import { AccountService } from '../../../services/account.service';
import { AuthService } from '../../../services/auth.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { OrganisationProfessionalVM } from '../../../models/OrganisationProfessionalVM';

@Component({
  selector: 'professionals',
  templateUrl: './professionals.component.html'
})
export class ProfessionalsComponent extends BaseComponent implements OnInit {

  //0 = professionals screens
  //1 = Joining Code Success
  //2 = Joining Code Failure
  mode: number = 0;

  issueJoiningCode: OrganisationProfessionalVM = new OrganisationProfessionalVM();

  filter: string = '';
  filterStatus: boolean = true;

  memberData: OrganisationProfessionalVM[] = [];
  memberTable: OrganisationProfessionalVM[] = [];
  newMember: OrganisationProfessionalVM = new OrganisationProfessionalVM();

  constructor(private router: Router,
    private route: ActivatedRoute,
    private accService: AccountService,
    private fb: FormBuilder
  ) {
    super(route);
  }

  ngOnInit(): void {

    // initial data load
    this.reloadData(null, true);

    this.myForm = this.fb.group({
      username: new FormControl('', [Validators.required, Validators.email])
    });

  }

  addMember() {
    this.markAsTouched(this.myForm);
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.accService.addProfessional(this.newMember)
        .subscribe(
          r => {
            this.emitDisplayLoadingDialog(false);
            if (r != null) {
              this.issueJoiningCode = r;
              this.mode = 1;
            }
            else {
              this.showDialog("The professional has already been added", false);
              this.mode = 0;
            }

            this.reloadData(null, false);
          },
          e => {
            console.log(e);
            this.showDialog(e, true);
            this.emitDisplayLoadingDialog(false);
          }
        );
    }
  }

  filterMembers() {
    var callback = () => {
      if (this.filter.length > 0) {
        // email filter str
        this.memberTable = this.memberData.filter((item, i) => {
          return (item.username.startsWith(this.filter));
        });
      }
    };

    this.reloadData(callback, true);
  }

  toggleMemberStatus(item: OrganisationProfessionalVM) {
    if (item.enabled) {
      this.emitDisplayLoadingDialog(true);
      this.accService.enableProfessional(item)
        .subscribe(
          r => {
            this.emitDisplayLoadingDialog(false);
            if (r) {
              this.showDialog("Professional enabled successfully", false);
            }
            else {
              this.showDialog("Failed to enabled professional", true);
            }

            this.reloadData(null, false);
          },
          e => {
            console.log(e);
            this.showDialog(e, true);
            this.emitDisplayLoadingDialog(false);
          }
        );
    }
    else {
      this.accService.disableProfessional(item)
        .subscribe(
          r => {
            this.emitDisplayLoadingDialog(false);
            if (r) {
              this.showDialog("Professional disabled successfully", false);
            }
            else {
              this.showDialog("Failed to disable professional", true);
            }

            this.reloadData(null, false);
          },
          e => {
            console.log(e);
            this.showDialog(e, true);
            this.emitDisplayLoadingDialog(false);
          }
        );
    }
  }

  reloadData(callback: () => void | null, withLoadingOverlay: boolean) {
    if (withLoadingOverlay) {
      this.emitDisplayLoadingDialog(true);
    }

    this.accService.getProfessionals(this.filterStatus).subscribe(
      r => {
        this.memberData = r;
        this.memberTable = r;

        if (callback != null) {
          callback();
        }

        if (withLoadingOverlay) {
          this.emitDisplayLoadingDialog(false);
        }
      },
      e => {
        console.log(e);
        if (withLoadingOverlay) {
          this.emitDisplayLoadingDialog(false);
        }
      }
    );
  }

  reissueJoiningCode(item: OrganisationProfessionalVM) {
    this.emitDisplayLoadingDialog(true);
    var self = this;
    this.accService.reissueJoiningCode(item)
      .subscribe(
        r => {
          if (r.status == 200) {
            this.showDialog("Professional has already joined your Organisation", true);
            this.cancel();
          }
          else if (r.status == 201) {
            self.issueJoiningCode = r.json() as OrganisationProfessionalVM;
            self.mode = 1;
          }
          this.emitDisplayLoadingDialog(false);
        },
        e => {
          console.log(e);
          this.showDialog(e, true);
          this.emitDisplayLoadingDialog(false);
        }
      );
  }

  cancel() {
    this.issueJoiningCode = new OrganisationProfessionalVM();
    this.newMember = new OrganisationProfessionalVM();
    this.myForm.reset();
    this.reloadData(null, false);
    this.mode = 0;
  }

}
